import Vue from 'vue'

import LayoutDefault from './Default'
import LayoutError from './Error'

Vue.component('LayoutDefault', LayoutDefault)
Vue.component('LayoutError', LayoutError)